import { render, staticRenderFns } from "./billing-file.vue?vue&type=template&id=2c790628&"
import script from "./billing-file.vue?vue&type=script&lang=js&"
export * from "./billing-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports